
















import { defineComponent, computed } from '@vue/composition-api';

import LoginAnimation from '@/renderer/components/login/components/loginAnimation.vue';

import store from '@/renderer/store';
import useSSOLogin from '@/renderer/components/login/compositions/useSSOLogin';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';

export default defineComponent({
  name: 'ssoLogin',
  components: {
    LoginAnimation,
  },
  setup(props, context) {
    const route = context.root.$route;
    const showInMobile = computed(() => store.getters.isMobile || store.getters.isMobileStyle);
    const thisYear = new Date().getFullYear();
    const { corpId, methods: ssoMethods } = useSSOLogin();

    const methods = {
      initInPublic() {
        const { corpId: corpIdQuery } = route.query;
        if (corpIdQuery) {
          corpId.value = corpIdQuery as string;
          ssoMethods.openSSOUrl({ path: '/login' }).then(success => {
            if (!success) {
              dispatchRouter({ name: 'login', query: { tab: 'loginWithSSO' } });
            }
          });
          return;
        }

        if (!CONSTANT_URL.isCustomizedDomain) {
          dispatchRouter({ name: 'login', query: { tab: 'loginWithSSO' } });
          return;
        }

        ssoMethods.openSSOUrl({ domain: CONSTANT_URL.currentDomain, path: '/login' }).then(success => {
          if (!success) {
            dispatchRouter({ name: 'login', query: { tab: 'loginWithSSO' } });
          }
        });
      },
      initInPrivate() {
        store.dispatch('getCorpList').then(() => {
          ssoMethods.initList({ noCache: true });

          if (!corpId.value) {
            tips.error(i18n_t('请联系运维管理员处理'));
            return;
          }
          ssoMethods.openSSOUrl({ path: '/login' });
        });
      },
      init() {
        if (store.getters.isPrivate) {
          methods.initInPrivate();
        } else {
          methods.initInPublic();
        }
      },
    };

    methods.init();

    return {
      thisYear,
      showInMobile,
      ...methods,
    };
  },
});
